
import { defineComponent, onMounted, ref, watch } from 'vue';
export default defineComponent({
    props: {
        active: Boolean,
    }
})
